import { css } from 'styled-components';
import { Uppercase } from './PlayUppercase.styles';
import { playFontSize } from './helpers';
import { fontWeightBold, regularWhite } from '../design-tokens';
import { device } from '../breakpoints';

export const PlayBadge = css`
    ${Uppercase}
    ${playFontSize(1)}
    font-weight: ${fontWeightBold};
    color: ${regularWhite};
    text-decoration: none;

    @media ${device.GteLarge} {
        ${playFontSize(1.1)}
    }
`;
